module.exports = __webpack_public_path__ + "img/16.cloudy-night-light.dcd9563c.svg";